import { defineStore } from 'pinia'
import localSave from '@utils/local-save'
import { usePremiumStore } from '@stores/premium'
import { effectiveQualityKey } from '@utils/audio-quality'

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        volume: localSave.get<number>('volume') ?? 25,
        currentOnDemandQualityKey: localSave.get<string>('currentOnDemandQualityKey') || 'low',
    }),
    getters: {
        // What the listener hears and sees selected; `currentOnDemandQualityKey` stays their choice.
        effectiveOnDemandQualityKey(state): string {
            return effectiveQualityKey(state.currentOnDemandQualityKey, usePremiumStore().isKnownNotPremium)
        },
    },
    actions: {
        setSettings({ volume, currentOnDemandQualityKey }) {
            if (volume !== undefined) {
                this.volume = volume
                localSave.save('volume', this.volume)
            }

            if (currentOnDemandQualityKey !== undefined) {
                this.currentOnDemandQualityKey = currentOnDemandQualityKey
            }
        },
    },
})
